module.exports = __webpack_public_path__ + "static/the-hard-way-29daea80cf6d32a58065d8e257a51a22.jpg";